import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	viewBox: "0 0 384 384",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M133.7 277.3h235.6c8.1 0 14.7 9.6 14.7 21.3 0 11.8-6.6 21.3-14.7 21.3H133.7c-8.1 0-14.7-9.6-14.7-21.3s6.6-21.3 14.7-21.3M21.3 170.7h341.3c11.8 0 21.3 9.6 21.3 21.3 0 11.8-9.6 21.3-21.3 21.3H21.3C9.6 213.3 0 203.8 0 192s9.6-21.3 21.3-21.3m0-106.7h341.3c11.8 0 21.3 9.6 21.3 21.3 0 11.8-9.6 21.3-21.3 21.3H21.3C9.6 106.7 0 97.1 0 85.3 0 73.6 9.6 64 21.3 64" })
});
export default SvgMenu;
